module.exports = __webpack_public_path__ + "img/liulei.bc360340.png";